<script lang="ts">
  /** 1 回の実行結果（コンパイラの出力・時間切れ・実行時エラー・標準出力） */
  import OutputPanel from '../OutputPanel.svelte';
  import VerdictBadge from '../VerdictBadge.svelte';
  import type { RunOutcomeView } from './run-lesson';

  interface Props {
    result: RunOutcomeView;
  }

  let { result }: Props = $props();
</script>

<div class="run-result" data-testid="run-result">
  {#if result.kind === 'compile-error'}
    <p class="note"><VerdictBadge verdict="CE" size="sm" /> コンパイルできませんでした。</p>
    <h4 class="sub">コンパイラの出力</h4>
    <!-- svelte-ignore a11y_no_noninteractive_tabindex -->
    <pre class="output" tabindex="0" aria-label="コンパイラの出力">{result.output}</pre>
  {:else}
    {#if result.kind === 'timeout'}
      <p class="note"><VerdictBadge verdict="TLE" size="sm" /> 3 秒以内に終わりませんでした。</p>
    {:else if result.kind === 'runtime-error'}
      <p class="note"><VerdictBadge verdict="RE" size="sm" /> 実行の途中で止まりました。</p>
    {/if}
    <OutputPanel
      mode="plain"
      stdout={result.stdout}
      stderr={result.stderr}
      durationMs={result.durationMs}
    />
  {/if}
</div>

<style>
  .run-result {
    display: flex;
    flex-direction: column;
    gap: var(--space-2);
    min-width: 0;
  }
  .note {
    display: flex;
    align-items: center;
    gap: var(--space-2);
    font-size: var(--fs-sm);
    color: var(--text-soft);
  }
  .sub {
    font-size: var(--fs-sm);
    color: var(--text-soft);
    font-weight: var(--fw-semibold);
  }
</style>
